import { createContract, extract } from '@exonet/jsonapi-fetcher/lib/resources';

const UC_RELATIONS = [
  'user',
  'roles',
  'email_addresses',
  'phone_numbers',
  'primary_email_address',
  'primary_phone_number',
];

const mapStateToProps = ({ api, app }, { userId }) => {
  if (!userId) return { userCustomer: null };

  const customerId = app?.customer?.id;
  const contract = customerId
    ? createContract('user_customers').filter('user', userId).filter('customer', customerId)
    : createContract('user_customers').filter('user', userId);

  const userCustomer =
    extract(contract, api).with(UC_RELATIONS).get('user_customers').first() || null;

  return { userCustomer };
};

export default [mapStateToProps];
